import React, { useEffect, useRef } from 'react';
import Form from './Form.js';
import FormInline from './FormInline.js';
import Header from './Header.js';
import Footer from './Footer.js';
import Modal from './Modal.js';

function Home() {
  return (
    <>
    <div className=" wrapper" suppressHydrationWarning>
      <Header/>
      <main className="page">
        <section className="offer">
          <div className="container offer__content">
            <div className="offer__wrap">
              <h1 className="offer__title" data-aos="fade-down">
                франшиза <span style={{ color: "#0d0d0d" }}>topkids:</span> 
                <span className="offer__title-blue">
                  Социально-значимый и востребованный продукт
                </span>
                <ul
                  className="center__benefits-list center-benefits-list list-reset"
                  data-aos="fade-left"
                >
                  <li className="center-benefits-list__item text">
                    <span>Прибыль от 250 000 рублей в месяц</span>
                  </li>
                  <li className="center-benefits-list__item text">
                    <span>Субсидии от государства</span>
                  </li>
                  <li className="center-benefits-list__item text">
                    <span>
                      Доведение до результата от головной компании
                    </span>
                  </li>
                </ul>
              </h1>
              <p className="offer__text" data-aos="fade-right">
                TopKids поделится с вами проверенными технологиями запуска,
                продаж и предоставления услуг.
              </p>
              <div className="offer__label" data-aos="fade-right">
                Получите презентацию франшизы и бизнес-план
              </div>
              <button
                data-hystmodal="#order-call"
                className="btn offer__btn btn-reset"
                data-aos="fade-right"
              >
                Получить информацию
              </button>
            </div>
            <ul
              className="offer__list list-reset offer-list"
              data-aos="fade-left"
            >
              <li className="offer-list__item">
                <span className="offer-list__arrow"></span>
                Поддержка основателей <span>с 17-летним опытом</span>
              </li>
              <li className="offer-list__item">
                <span>Собственные разработки</span> обучения дошкольников
              </li>
              <li className="offer-list__item">
                <span>Более 3000</span> довольных родителей
              </li>
            </ul>
          </div>
        </section>
        <section className="business">
          <div className="container business__content">
            <div className="business__dec1 dec"></div>
            <div className="business__dec2 dec"></div>
            <h2
              className="business__title title title--with-decor"
              data-aos="fade-down"
            >
              Бизнес-модель детского центра охватывает 14 услуг и опробована
              на 4 филиалах
            </h2>
            <p className="business__text text" data-aos="fade-down">
              Основатели TopKids стояли у истоков развития сферы
              коммерческого дошкольного образования. В 2005 году открыли
              студию раннего развития.{" "}
              <span>
                Сейчас TopKids — комплексный центр для детей от 1 года до 7
                лет с направлениями:
              </span>
            </p>
            <ul className="business__list business-list list-reset">
              <li
                className="business-list__item"
                data-aos="fade-down"
                data-aos-delay="0"
              >
                <picture className="business-list__photo">
                  <source
                    srcSet="/img/business/01.avif"
                    type="image/avif"
                  />
                  <source
                    srcSet="/img/business/01.webp"
                    type="image/webp"
                  />
                  <img
                    loading="lazy"
                    src="/img/business/01.png"
                    alt="Малыша"
                  />
                </picture>
                <h3 className="business-list__title">Детский сад</h3>
                <p className="business-list__text">
                  Группы полного и выходного дня.
                </p>
              </li>
              <li
                className="business-list__item"
                data-aos="fade-down"
                data-aos-delay="100"
              >
                <picture className="business-list__photo">
                  <source
                    srcSet="/img/business/02.avif"
                    type="image/avif"
                  />
                  <source
                    srcSet="/img/business/02.webp"
                    type="image/webp"
                  />
                  <img
                    loading="lazy"
                    src="/img/business/02.png"
                    alt="Мама и малыш"
                  />
                </picture>
                <h3 className="business-list__title">Мама и малыш</h3>
                <p className="business-list__text">
                  Познавательные, совместные занятия мамы и малыша. Лучший
                  способ знакомства с центром
                </p>
              </li>
              <li
                className="business-list__item"
                data-aos="fade-down"
                data-aos-delay="200"
              >
                <picture className="business-list__photo">
                  <source
                    srcSet="/img/business/03.avif"
                    type="image/avif"
                  />
                  <source
                    srcSet="/img/business/03.webp"
                    type="image/webp"
                  />
                  <img
                    loading="lazy"
                    src="/img/business/03.png"
                    alt="Девочка"
                  />
                </picture>
                <h3 className="business-list__title">Продлёнка</h3>
                <p className="business-list__text">
                  Группы продлённого дня для первоклассников.
                </p>
              </li>
              <li
                className="business-list__item"
                data-aos="fade-down"
                data-aos-delay="0"
              >
                <picture className="business-list__photo">
                  <source
                    srcSet="/img/business/04.avif"
                    type="image/avif"
                  />
                  <source
                    srcSet="/img/business/04.webp"
                    type="image/webp"
                  />
                  <img
                    loading="lazy"
                    src="/img/business/04.png"
                    alt="Дети"
                  />
                </picture>
                <h3 className="business-list__title">Мини-клуб</h3>
                <p className="business-list__text">
                  Группы неполного и выходного дня.
                </p>
              </li>
              <li
                className="business-list__item"
                data-aos="fade-down"
                data-aos-delay="100"
              >
                <picture className="business-list__photo">
                  <source
                    srcSet="/img/business/05.avif"
                    type="image/avif"
                  />
                  <source
                    srcSet="/img/business/05.webp"
                    type="image/webp"
                  />
                  <img
                    loading="lazy"
                    src="/img/business/05.png"
                    alt="Девочка"
                  />
                </picture>
                <h3 className="business-list__title">Подготовка к школе</h3>
                <p className="business-list__text">
                  Индивидуальные программы для каждой возрастной группы.
                </p>
              </li>
              <li
                className="business-list__item"
                data-aos="fade-down"
                data-aos-delay="200"
              >
                <picture className="business-list__photo">
                  <source
                    srcSet="/img/business/06.avif"
                    type="image/avif"
                  />
                  <source
                    srcSet="/img/business/06.webp"
                    type="image/webp"
                  />
                  <img
                    loading="lazy"
                    src="/img/business/06.png"
                    alt="мальчик"
                  />
                </picture>
                <h3 className="business-list__title">
                  Дополнительные занятия
                </h3>
                <p className="business-list__text">
                  Логопед, ментальная арифметика, скорочтение, английский
                  язык.
                </p>
              </li>
            </ul>
            <div className="text-block" data-aos="fade-down">
              Технологии TopKids обеспечивают высокую удовлетворённость
              клиентов и полную заполняемость детского центра.
              <span>
                Довольные клиенты + Высокая прибыль = «Бизнес-счастье»
              </span>
            </div>
          </div>
        </section>
        <section className="stat">
          <span className="stat__dec1 " data-aos="fade-right"></span>
          <span className="stat__dec2 " data-aos="fade-left"></span>
          <div className="container stat__content">
            <div className="stat__wrap">
              <h2 className="stat__title title" data-aos="fade-down">
                43% детей до 7 лет  уже получают дополнительное образование,
                и спрос на услуги стабильно растёт
              </h2>
              <p className="stat__text text" data-aos="fade-right">
                Рынок частных образовательных услуг в России в последние
                десятилетия устойчиво развивается.{" "}
                <span>Статистика подтверждает перспективы отрасли:</span>
              </p>
              <ul className="stat__list stat-list list-reset">
                <li
                  className="stat-list__item"
                  data-aos="fade-right"
                  data-aos-delay="0"
                >
                  <span className="stat-list__num">124 000</span>
                  <p className="stat-list__text">
                    детей родились в 2021 году.{" "}
                  </p>
                </li>
                <li
                  className="stat-list__item"
                  data-aos="fade-right"
                  data-aos-delay="50"
                >
                  <span className="stat-list__num">111 000</span>
                  <p className="stat-list__text">
                    человек в месяц ищут «частный детский сад» в интернете.
                  </p>
                </li>
                <li
                  className="stat-list__item"
                  data-aos="fade-right"
                  data-aos-delay="0"
                >
                  <span className="stat-list__num">1,9 млн</span>
                  <p className="stat-list__text">
                    человек стоят в очереди в государственные детские сады.
                  </p>
                </li>
                <li
                  className="stat-list__item"
                  data-aos="fade-right"
                  data-aos-delay="50"
                >
                  <span className="stat-list__num">{">"}8 млн</span>
                  <p className="stat-list__text">
                    воспитанников обучаются по программам дошкольного
                    образования.
                  </p>
                </li>
                <li
                  className="stat-list__item"
                  data-aos="fade-right"
                  data-aos-delay="0"
                >
                  <span className="stat-list__num">43%</span>
                  <p className="stat-list__text">
                    детей получают дополнительное образование.
                  </p>
                </li>
                <li
                  className="stat-list__item"
                  data-aos="fade-right"
                  data-aos-delay="50"
                >
                  <span className="stat-list__num">от 5 000</span>
                  <p className="stat-list__text">
                    рублей в месяц родители готовы платить за обучение.
                  </p>
                </li>
              </ul>
            </div>
            <ul
              className="stat__block stat-block list-reset"
              data-aos="fade-left"
            >
              <li className="stat-block__item text">
                <span>
                  {" "}
                  Самые востребованные бизнес-модели — детские центры,
                  предоставляющие комплекс услуг для разных возрастных
                  категорий.
                </span>{" "}
                Это экономит время и снижает уровень стресса — ребёнок
                получает интеллектуальное, творческое и физическое развитие
                в одном месте.
              </li>
              <li className="stat-block__item text">
                <span>
                  {" "}
                  Государственные и муниципальные учреждения неспособны
                  принять всех детей.
                </span>
                Существует постоянная проблема нехватки мест, поэтому спрос
                на частные детские сады и центры раннего развития стабильно
                растёт.
              </li>
              <li className="stat-block__item text">
                <span>
                  Высокий уровень оснащения объектов детского досуга
                  повышает их привлекательность для детей и родителей.
                </span>{" "}
                Детские центры обязаны соблюдать нормативы по безопасности
                игровых и учебных зон, поэтому закупают качественное
                современное оборудование и материалы.
              </li>
              <li className="stat-block__item text">
                <span>
                  {" "}
                  Вы можете открывать центры на каждые 100 тысяч населения.
                </span>{" "}
                С использованием технологий нашей франшизы этих условий
                достаточно, чтобы заполняемость центра была 100%.
              </li>
            </ul>
            <FormInline title='Получите дополнительную информацию в нашей презентации'/>
          </div>
        </section>
        <section className="leader">
          <div className="container leader__content">
            <h2
              className="leader__title title title--with-decor"
              data-aos="fade-down"
            >
              За 17 лет из скромной студии в Благовещенске развились
              до лидера дошкольного образования в родном регионе
            </h2>
            <p className="leader__text text" data-aos="fade-down">
              <span>
                {" "}
                История TopKids началась в 2005 году с маленького
                образовательного центра.
              </span>
              Основателями двигало искреннее желание помогать родителям
              в раскрытии потенциала детей, развитии способностей
              и подготовке к школе.
            </p>
            <ul className="leader__list leader-list list-reset">
              <li
                className="leader-list__item"
                data-aos="fade-right"
                data-aos-delay="0"
              >
                <span className="leader-list__year">2005 год</span>
                <p className="leader-list__text text">
                  открытие студии раннего развития в арендованной квартире
                </p>
              </li>
              <li
                className="leader-list__item"
                data-aos="fade-right"
                data-aos-delay="50"
              >
                <span className="leader-list__year">2008 год</span>
                <p className="leader-list__text text">
                  покупка в ипотеку квартиры площадью 102 кв. м. с отдельным
                  входом и открытие детского сада на 16 мест.
                </p>
              </li>
              <li
                className="leader-list__item"
                data-aos="fade-right"
                data-aos-delay="100"
              >
                <span className="leader-list__year">2010 год</span>
                <p className="leader-list__text text">
                  покупка соседней квартиры в 79 кв. м., объединение
                  площадей и открытие дополнительной группы на 12 мест.
                  Открытие 2-й точки — детского сада на 16 мест и студии
                  раннего развития в арендованном помещении.
                </p>
              </li>
              <li
                className="leader-list__item"
                data-aos="fade-left"
                data-aos-delay="100"
              >
                <span className="leader-list__year">2017 год</span>
                <p className="leader-list__text text">
                  увеличение арендованной площади со 106 до 120 кв. м.
                  Лицензирование и открытие групп для детей 4–6,5 лет.
                </p>
              </li>
              <li
                className="leader-list__item"
                data-aos="fade-left"
                data-aos-delay="0"
              >
                <span className="leader-list__year">2012 год</span>
                <p className="leader-list__text text">
                  покупка в ипотеку квартиры 119 кв. м. в новом микрорайоне
                  города и открытие яслей на 18+ мест и студии РР.
                </p>
              </li>
              <li
                className="leader-list__item"
                data-aos="fade-left"
                data-aos-delay="0"
              >
                <span className="leader-list__year">2011 год</span>
                <p className="leader-list__text text">
                  досрочное погашение ипотеки.
                </p>
              </li>
            </ul>
            <div className="center">
              <div className="center__info" data-aos="fade-right">
                <picture className="center__photo">
                  <source srcSet="/img/leader/logo.avif" type="image/avif" />
                  <source srcSet="/img/leader/logo.webp" type="image/webp" />
                  <img
                    loading="lazy"
                    src="/img/leader/logo.jpg"
                    alt="Логотип центра"
                  />
                </picture>
                <div className="center__label">
                  Сегодня в Благовещенске работают 3 центра TopKids:
                </div>
                <ul className="center__list center-list list-reset">
                  <li className="center-list__item">
                    2 группы на ул. Горького, 42
                  </li>
                  <li className="center-list__item">
                    1 группа на ул. Воронкова, 19
                  </li>
                  <li className="center-list__item">
                    1 группа на ул. Политехнической, 144
                  </li>
                </ul>
              </div>
              <ul
                className="center__benefits-list center-benefits-list list-reset"
                data-aos="fade-left"
              >
                <li className="center-benefits-list__item text">
                  <div className="center-benefits-list__dec"></div>
                  <span>
                    {" "}
                    Центр предлагает возможность пребывания детей
                    от 1,5 до 7 лет
                  </span>
                   — от яслей до выпуска из детского сада
                </li>
                <li className="center-benefits-list__item text">
                  <span>
                    {" "}
                    Все филиалы центра лицензированы и получают ежемесячные
                    субсидии по 97 тысяч рублей на каждый объект.
                  </span>{" "}
                  Один из филиалов работает по региональной программе
                  Сертификатов — свободные места передали для очередников.
                  Городские власти ежемесячно перечисляют по 10 тысяч рублей
                  на каждого ребёнка, а родители самостоятельно доплачивают
                  до полной стоимости.
                </li>
                <li className="center-benefits-list__item text">
                  <span> Детские центры — социально значимый бизнес,</span>{" "}
                  поддерживаемый правительством на региональном
                  и федеральном уровнях
                </li>
                <li className="center-benefits-list__item text">
                  <span>
                    Франшиза TopKids — возможность начать успешный бизнес
                  </span>{" "}
                  с поддержкой опытных наставников, государственных грантов
                  и субсидий
                </li>
              </ul>
            </div>
          </div>
        </section>
        <section className="reviews">
          <div className="container reviews__content">
            <div className="reviews__dec1 dec"></div>
            <h2 className="reviews__title title" data-aos="fade-down">
              Родители спокойны за своих детей и благодарят за результаты
              обучения и воспитания их детей
            </h2>
            <p className="reviews__text text" data-aos="fade-right">
              <span>
                {" "}
                Безопасность ребёнка, внимание и забота, всесторонне
                развивающие занятия
              </span>
               — основные принципы работы центра. Родители признательны
              руководителю Швейкус Галине Валентиновне, а также педагогам
              и рекомендуют TopKids.
            </p>
            <ul className="reviews__list reviews-list list-reset">
              <li
                className="reviews-list__item reviews-list__item--horisontal"
                data-aos="fade-down"
              >
                <picture className="reviews-list__photo">
                  <source srcSet="/img/reviews/01.avif" type="image/avif" />
                  <source srcSet="/img/reviews/01.webp" type="image/webp" />
                  <img
                    loading="lazy"
                    src="/img/reviews/01.jpg"
                    alt="женщина"
                  />
                </picture>
                <div className="reviews-list__info">
                  <p className="reviews-list__text text">
                    При каждой встречи все детки из группы бегут
                    к воспитателям целуют и обнимают их! Я оставляю ребёнка
                    в садике и могу спокойно заниматься делами, зная
                    что малыш под постоянным контролем. В нашем садике
                    всегда чисто. Отдельно хочу выразить благодарность
                    и признательность руководителю Topkids Швейкус Галине
                    Валентиновне за то, что вы создали такой прелестный
                    садик для деток всех возрастов и подарили Родителям
                    спокойствие! Уважаемые родители, которые хотят отдать
                    детишек в садик «ТопКидс»: будьте спокойны, ваши детки
                    будут под надёжным присмотром и заботой!
                  </p>
                  <span className="reviews-list__name">Анна</span>
                </div>
              </li>
              <li className="reviews-list__item" data-aos="fade-right">
                <picture className="reviews-list__photo">
                  <source srcSet="/img/reviews/02.avif" type="image/avif" />
                  <source srcSet="/img/reviews/02.webp" type="image/webp" />
                  <img
                    loading="lazy"
                    src="/img/reviews/02.jpg"
                    alt="женщина c ребенком"
                  />
                </picture>
                <div className="reviews-list__info">
                  <p className="reviews-list__text text">
                    Очень благодарна центру «ТопКидс», а в особенности
                    Виктории Валентиновне. за тёплый приём моего ребёнка
                    в свой центр. Виктория Валентиновна по истине чудесный
                    человек, искренне любящий свою работу! Ребёнок многое
                    узнал с вами и познал! Спасибо за все вам!
                  </p>
                  <span className="reviews-list__name">
                    Марина, мама Артёма
                  </span>
                </div>
              </li>
              <li className="reviews-list__item" data-aos="fade-left">
                <picture className="reviews-list__photo">
                  <source srcSet="/img/reviews/03.avif" type="image/avif" />
                  <source srcSet="/img/reviews/03.webp" type="image/webp" />
                  <img
                    loading="lazy"
                    src="/img/reviews/03.jpg"
                    alt="женщина c ребенком"
                  />
                </picture>
                <div className="reviews-list__info">
                  <p className="reviews-list__text text">
                    В наш детский сад Андрея ходит с удовольствием, всегда
                    в настроении! Там каждое утро его встречает Виктория
                    Валентиновна. Самая добрая и внимательная! Я вижу только
                    одни плюсы от прибывания в топкидс моего сына!
                    Благоприятная обстановка сказывается на ребёнке!
                    А это для меня самое важное! Спасибо вам огромное
                    за доброе, нежное и тёплое отношение к детям!
                  </p>
                  <span className="reviews-list__name">
                    Наташа, мама Андрея
                  </span>
                </div>
              </li>
            </ul>
            <FormInline title='Станьте частью нашей франчайзинговой семьи' button='Узнать больше'/>
          </div>
        </section>
        <section className="investments">
          <div className="container investments__content">
            <h2
              className="investments__title title title--with-decor"
              data-aos="fade-down"
            >
              Оптимальные вложения для открытия успешного бизнеса
              по франшизе TopKids
            </h2>
            <p className="investments__text text" data-aos="fade-down">
              <span>
                Мы рассчитали сумму инвестиций, включая расходы на аренду,
                ремонт, вывеску, закупку оборудования, игрушек, обучающих
                материалов для открытия центра площадью от 100 кв. м.
              </span>
            </p>
            <div className="investments__block investments-block">
              <h3 className="investments-block__title">
                Инвестиции на открытие — от 1 млн рублей.
              </h3>
              <ul
                className="investments__list investments-list list-reset"
                data-aos="fade-right"
              >
                <li className="investments-list__title">
                  <h4>Паушальный взнос</h4>
                </li>
                <li className="investments-list__item">
                  <div className="investments-list__item-text">
                    Город с населением менее 500 тысяч человек
                  </div>
                  <div className="investments-list__item-sum">
                    300 тысяч рублей
                  </div>
                </li>
                <li className="investments-list__item">
                  <div className="investments-list__item-text">
                    Город с населением менее 1`000`000 человек
                  </div>
                  <div className="investments-list__item-sum">
                    400 тысяч рублей
                  </div>
                </li>
                <li className="investments-list__item">
                  <div className="investments-list__item-text">
                    Город с населением более 1`000`000 человек
                  </div>
                  <div className="investments-list__item-sum">
                    500 тысяч рублей
                  </div>
                </li>
                <li className="investments-list__item">
                  <div className="investments-list__item-text">
                    Эксклюзив на город
                  </div>
                  <div className="investments-list__item-sum investments-list__item-sum--from">
                    750 тысяч рублей
                  </div>
                </li>
              </ul>
              <ul
                className="investments__list investments-list list-reset"
                data-aos="fade-left"
              >
                <li className="investments-list__title">
                  <h4>Роялти</h4>
                </li>
                <li className="investments-list__item">
                  <div className="investments-list__item-text">
                    Город с населением менее 500 тысяч человек
                  </div>
                  <div className="investments-list__item-sum">
                    30 тысяч рублей
                  </div>
                </li>
                <li className="investments-list__item">
                  <div className="investments-list__item-text">
                    Город с населением менее 1`000`000 человек
                  </div>
                  <div className="investments-list__item-sum">
                    35 тысяч рублей
                  </div>
                </li>
                <li className="investments-list__item">
                  <div className="investments-list__item-text">
                    Город с населением более 1`000`000 человек
                  </div>
                  <div className="investments-list__item-sum">
                    40 тысяч рублей
                  </div>
                </li>
                <li className="investments-list__item">
                  <div className="investments-list__item-text">
                    Эксклюзив на город или регион
                  </div>
                  <div className="investments-list__item-sum">
                    25 тысяч рублей
                  </div>
                </li>
              </ul>
            </div>
            <div
              className="text-block investments__text-block"
              data-aos="fade-down"
            >
              <span>
                Успейте открыть детский центр по франшизе TopKids в своём
                городе
              </span>
              Сейчас самое благоприятное время — растущий спрос
              и возможность получить меры государственной поддержки
            </div>
          </div>
        </section>
        <section className="indicators">
          <div className="container indicators__content">
            <div className="indicators__dec dec"></div>
            <h2 className="indicators__title title" data-aos="fade-down">
              Финансовые показатели франшизы
            </h2>
            <p className="indicators__text text" data-aos="fade-right">
              <span>
                Основные экономические показатели работы детского сада{" "}
              </span>{" "}
              на 18 мест площадью до 100 кв. м. с заполняемостью 90–100%:
            </p>
            <div className="indicators__block">
              <ul
                className="indicators__list indicators-list list-reset"
                data-aos="fade-right"
              >
                <li className="indicators-list__item">
                  <div className="indicators-list__text">
                    Паушальный взнос
                  </div>
                  <div className="indicators-list__price">
                    от 300 000 руб.
                  </div>
                </li>
                <li className="indicators-list__item">
                  <div className="indicators-list__text">Инвестиции</div>
                  <div className="indicators-list__price">
                    от 1 000 000 руб.
                  </div>
                </li>
                <li className="indicators-list__item">
                  <div className="indicators-list__text">Выручка</div>
                  <div className="indicators-list__price">790 000 руб.</div>
                </li>
                <li className="indicators-list__item indicators-list__item--withbg">
                  <div className="indicators-list__text indicators-list__text--bold">
                    Чистая прибыль в месяц
                  </div>
                  <div className="indicators-list__price indicators-list__price--bold">
                    от 250 000 руб.
                  </div>
                </li>
                <li className="indicators-list__item ">
                  <div className="indicators-list__text">
                    Срок выхода на плановую прибыль
                  </div>
                  <div className="indicators-list__price">от 6 мес.</div>
                </li>
                <li className="indicators-list__item">
                  <div className="indicators-list__text">
                    Окупаемость при использовании собственных средств
                  </div>
                  <div className="indicators-list__price">4 — 9 мес.</div>
                </li>
                <li className="indicators-list__item">
                  <div className="indicators-list__text">
                    Окупаемость при использовании кпедитных средств
                  </div>
                  <div className="indicators-list__price">8 — 12 мес.</div>
                </li>
                <li className="indicators-list__item indicators-list__item--withbg">
                  <div className="indicators-list__text indicators-list__text--bold">
                    Рентабельность
                  </div>
                  <div className="indicators-list__price indicators-list__price--bold">
                    от 30%
                  </div>
                </li>
              </ul>
              <div className="indicators__images" data-aos="fade-left">
                <picture className="indicators__images-photo">
                  <source
                    srcSet="/img/indicators/photo.avif"
                    type="image/avif"
                  />
                  <source
                    srcSet="/img/indicators/photo.webp"
                    type="image/webp"
                  />
                  <img
                    loading="lazy"
                    src="/img/indicators/photo.jpg"
                    alt="дети"
                  />
                </picture>
                <picture className="indicators__images-logo">
                  <source srcSet="/img/logo.avif" type="image/avif" />
                  <source srcSet="/img/logo.webp" type="image/webp" />
                  <img loading="lazy" src="/img/logo.jpg" alt="логотип" />
                </picture>
              </div>
              <FormInline title='Станьте частью нашей франчайзинговой семьи' button='Узнать больше'/>
            </div>
          </div>
        </section>
        <section className="calculation">
          <div className="container calculation__content">
            <h2
              className="calculation__title title title--with-decor"
              data-aos="fade-down"
            >
              Посчитайте загрузку Центра для выхода на плановую прибыль
            </h2>
            <p className="calculation__text text" data-aos="fade-down">
              <span>
                Введите данные и рассчитайте финансовые показатели Вашей
                будущей сети детских садов и центров раннего развития.
              </span>
            </p>
            <div className="calculation__block" data-aos="fade-right">
              <ul className="calc list-reset calculation__calc">
                <li className="calc__item">
                  <p className="calc__text">Инвестиции (млн. руб)</p>
                  <div className="calc__field">
                    <input
                      type="range"
                      step="0.4"
                      min="1"
                      max="3"
                      className="calc__input"
                      defaultValue="1.8"
                      style={{
                        background:
                          "linear-gradient(to right, rgb(15, 164, 222) 0px, rgb(15, 164, 222) 40%, rgb(226, 237, 248) 40%, rgb(226, 237, 248) 100%)",
                      }}
                    />
                  </div>
                  <div className="calc__indicators">
                    <span className="calc__indicators-item">1</span>
                    <span className="calc__indicators-item">1.4</span>
                    <span className="calc__indicators-item">1.8</span>
                    <span className="calc__indicators-item">2.2</span>
                    <span className="calc__indicators-item">2.6</span>
                    <span className="calc__indicators-item">3</span>
                  </div>
                </li>
                <li className="calc__item">
                  <p className="calc__text">Процент личных средств (%)</p>
                  <div className="calc__field">
                    <input
                      type="range"
                      step="10"
                      min="10"
                      max="100"
                      className="calc__input"
                      defaultValue="30"
                      style={{
                        background:
                          "linear-gradient(to right, rgb(15, 164, 222) 0px, rgb(15, 164, 222) 22.2222%, rgb(226, 237, 248) 22.2222%, rgb(226, 237, 248) 100%)",
                      }}
                    />
                  </div>
                  <div className="calc__indicators">
                    <span className="calc__indicators-item">10</span>
                    <span className="calc__indicators-item">20</span>
                    <span className="calc__indicators-item">30</span>
                    <span className="calc__indicators-item">40</span>
                    <span className="calc__indicators-item">50</span>
                    <span className="calc__indicators-item">60</span>
                    <span className="calc__indicators-item">70</span>
                    <span className="calc__indicators-item">80</span>
                    <span className="calc__indicators-item">90</span>
                    <span className="calc__indicators-item">100</span>
                  </div>
                </li>
                <li className="calc__item">
                  <p className="calc__text">Кредитная ставка (%)</p>
                  <div className="calc__field">
                    <input
                      type="range"
                      step="1"
                      min="11"
                      max="17"
                      className="calc__input"
                      defaultValue="15"
                      style={{
                        background:
                          "linear-gradient(to right, rgb(15, 164, 222) 0px, rgb(15, 164, 222) 66.6667%, rgb(226, 237, 248) 66.6667%, rgb(226, 237, 248) 100%)",
                      }}
                    />
                  </div>
                  <div className="calc__indicators">
                    <span className="calc__indicators-item">0.5*</span>
                    <span className="calc__indicators-item">12</span>
                    <span className="calc__indicators-item">13</span>
                    <span className="calc__indicators-item">14</span>
                    <span className="calc__indicators-item">15</span>
                    <span className="calc__indicators-item">16</span>
                    <span className="calc__indicators-item">17</span>
                  </div>
                </li>
                <li className="calc__item">
                  <p className="calc__text">Срок кредитования (года)</p>
                  <div className="calc__field">
                    <input
                      type="range"
                      step="12"
                      min="12"
                      max="60"
                      className="calc__input"
                      defaultValue="36"
                      style={{
                        background:
                          "linear-gradient(to right, rgb(15, 164, 222) 0px, rgb(15, 164, 222) 50%, rgb(226, 237, 248) 50%, rgb(226, 237, 248) 100%)",
                      }}
                    />
                  </div>
                  <div className="calc__indicators">
                    <span className="calc__indicators-item">1</span>
                    <span className="calc__indicators-item">2</span>
                    <span className="calc__indicators-item">3</span>
                    <span className="calc__indicators-item">4</span>
                    <span className="calc__indicators-item">5</span>
                  </div>
                </li>
                <li className="calc__item">
                  <p className="calc__text">
                    Количество проданных занятий (шт)
                  </p>
                  <div className="calc__field">
                    <input
                      type="range"
                      step="30"
                      min="230"
                      max="350"
                      className="calc__input"
                      defaultValue="320"
                      style={{
                        background:
                          "linear-gradient(to right, rgb(15, 164, 222) 0px, rgb(15, 164, 222) 75%, rgb(226, 237, 248) 75%, rgb(226, 237, 248) 100%)",
                      }}
                    />
                  </div>
                  <div className="calc__indicators">
                    <span className="calc__indicators-item">230</span>
                    <span className="calc__indicators-item">260</span>
                    <span className="calc__indicators-item">290</span>
                    <span className="calc__indicators-item">320</span>
                    <span className="calc__indicators-item">350</span>
                  </div>
                </li>
                <li className="calc__item">
                  <p className="calc__text">
                    Средняя стоимость занятий (руб)
                  </p>
                  <div className="calc__field">
                    <input
                      type="range"
                      step="150"
                      min="2400"
                      max="3300"
                      className="calc__input"
                      defaultValue="2700"
                      style={{
                        background:
                          "linear-gradient(to right, rgb(15, 164, 222) 0px, rgb(15, 164, 222) 33.3333%, rgb(226, 237, 248) 33.3333%, rgb(226, 237, 248) 100%)",
                      }}
                    />
                  </div>
                  <div className="calc__indicators">
                    <span className="calc__indicators-item">2400</span>
                    <span className="calc__indicators-item">2550</span>
                    <span className="calc__indicators-item">2700</span>
                    <span className="calc__indicators-item">2850</span>
                    <span className="calc__indicators-item">3000</span>
                    <span className="calc__indicators-item">3150</span>
                    <span className="calc__indicators-item">3300</span>
                  </div>
                </li>
              </ul>
              <div className="calculation__table calculation-table">
                <div className="calculation-table__item">
                  <div className="calculation-table__text">
                    Чистая ежемесечная прибыль без платежей по кредиту:
                  </div>
                  <div className="calculation-table__result">
                    <span className=" calculation-table__result-num--profit rub">
                      233 280,00
                    </span>
                  </div>
                </div>
                <div className="calculation-table__item">
                  <div className="calculation-table__text">
                    Платёж по кредиту:
                  </div>
                  <div className="calculation-table__result">
                    <span className="calculation-table__result-num calculation-table__result-num--payment rub">
                      43 678,31
                    </span>
                  </div>
                </div>
                <div className="calculation-table__item">
                  <div className="calculation-table__text">
                    Чистая ежемесячная прибыль:
                  </div>
                  <div className="calculation-table__result">
                    <span className="calculation-table__result-num calculation-table__result-num--clean rub">
                      189 601,69
                    </span>
                  </div>
                </div>
                <div className="calculation-table__item">
                  <div className="calculation-table__text">
                    Срок окупаемости:
                  </div>
                  <div className="calculation-table__result">
                    <span className="calculation-table__result-num calculation-table__result-num--period">
                      10
                    </span>
                    месяцев
                  </div>
                </div>
              </div>
              <div className="calculation__info">
                *Все филиалы сети центров ТопКидс принимают участие
                в программах по социальному предпринимательству и приобретая
                нашу франшизу, вы получаете доступ к различным программам
                софинансирования бизнеса, в том числе и микрозаймы
                по льготной ставке — не более 0,5% ключевой ставки
                Центробанка.
              </div>
              <div className="calculation__wrap">
                <div className="calculation__label">
                  Получите подробный бизнес-план, чтобы узнать все
                  экономические показатели, а также краткосрочные
                  и долгосрочные перспективы развития собственной сети.
                </div>
                <button
                  className="calculation__btn btn btn-reset"
                  data-hystmodal="#order-call"
                >
                  Получить бизнес-план
                </button>
              </div>
            </div>
          </div>
        </section>
        <section className="steps">
          <div className="container steps__content">
            <h2 className="steps__title title" data-aos="fade-down">
              5 этапов запуска собственного детского центра: от подписания
              договора до торжественного открытия
            </h2>
            <p className="steps__text text" data-aos="fade-right">
              <span>
                Окажем комплексную поддержку франчайзи-партнёру на всех
                этапах запуска
              </span>{" "}
              детского сада, а также передадим наработанные за 17 лет
              деятельности ноу-хау.
            </p>

            <ul className="steps__list steps-list list-reset">
              <li
                className="steps-list__item"
                data-aos="fade-down"
                data-aos-delay="0"
              >
                <div className="steps-list__day">1 день</div>
                <p className="steps-list__text">
                  Заключим лицензионный договор и зафиксируем все условия
                  сотрудничества.
                </p>
                <span className="steps-list__block">Старт</span>
              </li>
              <li
                className="steps-list__item"
                data-aos="fade-down"
                data-aos-delay="50"
              >
                <div className="steps-list__day">7-10 день</div>
                <p className="steps-list__text">
                  поможем выбрать подходящее помещение в районе города,
                  где проживает много молодых семей с детьми. Проведём
                  обучение франчайзи-партнёра, ознакомим с правилами работы.
                </p>
              </li>
              <li
                className="steps-list__item"
                data-aos="fade-down"
                data-aos-delay="100"
              >
                <div className="steps-list__day">до 30 дней</div>
                <p className="steps-list__text">
                  поможем подготовить помещение к открытию — передадим
                  современный дизайн-проект для ремонта, перечень
                  необходимого оборудования, игровых и обучающих материалов,
                  а также окажем помощь в подборе квалифицированного
                  персонала
                </p>
              </li>
              <li
                className="steps-list__item"
                data-aos="fade-down"
                data-aos-delay="0"
              >
                <div className="steps-list__day">
                  До 70 дней (параллельно с этапом 3)
                </div>
                <p className="steps-list__text">
                  Комплексное сопровождение, поможем получить Лицензию
                  на образовательную деятельность и на оказание услуг
                  дополнительного образования. Заключения Роспотребнадзора
                  и Роспожнадзора. Возможен выезд сотрудника со стороны
                  франчайзера. Запустим рекламную кампанию.
                </p>
              </li>
              <li
                className="steps-list__item"
                data-aos="fade-down"
                data-aos-delay="50"
              >
                <div className="steps-list__day">1 день</div>
                <p className="steps-list__text">
                  торжественное открытие и начало продаж.
                </p>
                <span className="steps-list__block">Финиш</span>
              </li>
              <li
                className="steps-list__item steps-list__item--blue"
                data-aos="fade-down"
                data-aos-delay="100"
              >
                <p className="steps-list__text">
                  После начала деятельности будем консультировать по всем
                  операционным вопросам — организации режима дня, работе
                  с родителями, оформлению отчётной документации, получению
                  лицензий и другим
                </p>
              </li>
              <li
                className="steps-list__dec dec"
                data-rellax-speed="-2"
              ></li>
            </ul>
            <div
              className="text-block text-block--with-photo steps__text-block"
              data-aos="fade-down"
            >
              <div className="text-block__info">
                <span>
                  По аналогичной технологии запустили филиал в г. Мытищи.{" "}
                </span>
                Несмотря на пандемию и использование заёмных средств филиал
                успешно вышел на плановые показатели и обучает детишек
                по настоящее время.
              </div>
              <picture className="text-block__photo">
                <source srcSet="/img/steps/photo.avif" type="image/avif" />
                <source srcSet="/img/steps/photo.webp" type="image/webp" />
                <img
                  loading="lazy"
                  src="/img/steps/photo.jpg"
                  alt="магазин"
                />
              </picture>
            </div>
            <FormInline 
              title='Получите на почту подробную информацию по открытию бизнеса по франшизе TopKids за 3 месяца'
              button='Узнать больше'
            />
          </div>
        </section>
        <section className="partners">
          <div className="container partners__content">
            <h2
              className="partners__title title title--with-decor"
              data-aos="fade-down"
            >
              Кого мы видим потенциальным партнёром TopKids
            </h2>
            <p className="partners__text text" data-aos="fade-down">
              Бизнес-модель по запуску детского сада и студии раннего
              развития подходит для городов с населением от 100 тысяч
              человек.{" "}
              <span>Присоединяйтесь к франшизе TopKids, если вы:</span>
            </p>
            <ul className="partners__list partners-list list-reset">
              <li
                className="partners-list__item"
                data-aos="fade-down"
                data-aos-delay="0"
              >
                <picture className="partners-list__photo">
                  <source
                    srcSet="/img/partners/01.avif"
                    type="image/avif"
                  />
                  <source
                    srcSet="/img/partners/01.webp"
                    type="image/webp"
                  />
                  <img
                    loading="lazy"
                    src="/img/partners/01.png"
                    alt="Малыш"
                  />
                </picture>
                <p className="partners-list__text">
                  Работали сфере детского образования от 3-х лет.
                </p>
              </li>
              <li
                className="partners-list__item"
                data-aos="fade-down"
                data-aos-delay="50"
              >
                <picture className="partners-list__photo">
                  <source srcSet="/img/partners/02.avif" type="image/avif" />
                  <source srcSet="/img/partners/02.webp" type="image/webp" />
                  <img
                    loading="lazy"
                    src="/img/partners/02.png"
                    alt="доска"
                  />
                </picture>
                <p className="partners-list__text">
                  Получили опыт в муниципальных учреждениях
                </p>
              </li>
              <li
                className="partners-list__item"
                data-aos="fade-down"
                data-aos-delay="100"
              >
                <picture className="partners-list__photo">
                  <source srcSet="/img/partners/03.avif" type="image/avif" />
                  <source srcSet="/img/partners/03.webp" type="image/webp" />
                  <img
                    loading="lazy"
                    src="/img/partners/03.png"
                    alt="Девушка"
                  />
                </picture>
                <p className="partners-list__text">
                  Начинающий предприниматель, который выбирает бизнес
                  по призванию наряду с финансовыми показателями
                </p>
              </li>
              <li
                className="partners-list__item"
                data-aos="fade-down"
                data-aos-delay="0"
              >
                <picture className="partners-list__photo">
                  <source srcSet="/img/partners/04.avif" type="image/avif" />
                  <source srcSet="/img/partners/04.webp" type="image/webp" />
                  <img
                    loading="lazy"
                    src="/img/partners/04.png"
                    alt="Игрушки"
                  />
                </picture>
                <p className="partners-list__text">
                  {" "}
                  Владелец детских развлекательных центров.
                </p>
              </li>
              <li
                className="partners-list__item"
                data-aos="fade-down"
                data-aos-delay="50"
              >
                <picture className="partners-list__photo partners-list__photo--big">
                  <source srcSet="/img/partners/05.avif" type="image/avif" />
                  <source srcSet="/img/partners/05.webp" type="image/webp" />
                  <img
                    loading="lazy"
                    src="/img/partners/05.png"
                    alt="Школа"
                  />
                </picture>
                <p className="partners-list__text">
                  Владелец частной школы.
                </p>
              </li>
            </ul>
            <div
              className="partners__text-block text-block"
              data-aos="fade-down"
            >
              Желательно высшее педагогическое или экономическое образование
              и наличие в собственности коммерческой недвижимости.
              <span>
                Предварительно проведём переговоры — если мы подойдём друг
                другу, то будем рады видеть в рядах единомышленников.
              </span>
            </div>
          </div>
        </section>
        <section className="lets">
          <div className="container lets__content">
            <div className="lets__dec dec"></div>
            <h2 className="lets__title" data-aos="fade-down">
              <span className="lets__title-blue">
                {" "}
                Станьте франчайзи-партнёром TopKids
              </span>
               — откройте бизнес в перспективной нише частных детских садов{" "}
              <br />
              <span className="lets__title-bord">
                и развивайте собственную сеть
              </span>
            </h2>
            <p className="lets__text text" data-aos="fade-down">
              <span>
                Запустите бизнес при поддержке партнёра с 17-летним опытом
                в сфере дошкольного образования. Позвоните менеджеру
                по телефону <a href="tel:+79145866771">+7 914 586 67 71</a>,
                чтобы задать интересующие вопросы и назначить время
                стартовых переговоров.
              </span>
            </p>
            <div className="lets__wrap">
              <Form 
                title='Получите на почту подробную информацию по открытию бизнеса по франшизе TopKids за 3 месяца'
                className={'lets__form form form--vertical aos-init aos-animate'}
              />
              <picture className="lets__photo" data-aos="fade-left">
                <source srcSet="/img/lets/photo.avif" type="image/avif" />
                <source srcSet="/img/lets/photo.webp" type="image/webp" />
                <img
                  loading="lazy"
                  src="/img/lets/photo.png"
                  alt="женщина"
                />
              </picture>
            </div>
          </div>
        </section>
      </main>
      <Footer/>
      <Modal/>                
    </div>
    <script src="/js/main.js" async />           
    </>
  );
}

export default Home;
